import {
  PATH_CLAIMS_COL,
  PATH_CLAIMS_PER,
  PATH_FACEBOOK,
  PATH_INSTAGRAM_CHL,
  PATH_INSTAGRAM_LATAM,
  PATH_LINKEDIN,
  PATH_PAGE99,
  PATH_SUPPLIER,
  PATH_TIKTOK,
  PATH_YOUTUBE,
  PATH_ZENDESK,
  PATH_ZENDESK_COL,
} from '@/routes/paths';
import { Event, EventAction, EventCategory } from '@/utils/goggleAnalytics/gtag';

import type { IEvent } from '@/utils/goggleAnalytics/gtag';

export type ILinksOthers = Record<string, ILinksOthersValues[]>;

export type ILinksOthersValues = ILinksOthersValuesModal | ILinksOthersValuesLink;

export interface ILinksOthersValuesModal {
  headline: string;
  action: Action.Modal;
  modal: string;
  event: IEvent;
}

export interface ILinksOthersValuesLink {
  headline: string;
  action: Action.Link;
  href: string;
  target?: string;
  event: IEvent;
}

export enum Action {
  Link = 'link',
  Modal = 'modal',
}

export type CountriesCode = 'MX' | 'CO' | 'CL' | 'PE';

export interface ILinks {
  headline: string;
  countries: CountriesCode[];
  children: ILinkChild[];
}

export interface ILinkChild {
  name: string;
  href: string;
  countries: string[];
  event: IEvent;
  hrefOriginal?: string;
  external?: boolean;
}

export type IMedia = Record<string, IMediaValues[]>;

export interface IMediaValues {
  name: string;
  path: string;
  url: string;
  event: IEvent;
}

export interface IRightsValues {
  name: string;
  path: string;
  event: IEvent;
  countries: CountriesCode[];
}

export type GetInvoices = Record<
  CountriesCode,
  {
    subtitle?: string;
    mailto?: string;
    mailtoCC?: string;
    items:
      | Array<{
          title?: string;
          children?: string[];
        }>
      | string[];
  }
>;

export const FooterLinks: ILinks[] = [
  {
    headline: 'COMMON.MENU.PRODUCTS',
    countries: ['MX', 'CL', 'CO', 'PE'],
    children: [
      {
        name: 'COMMON.MENU.SUBMENUS.PRODUCTS.DELIVERY',
        href: PATH_PAGE99.product.delivery,
        countries: ['MX', 'CL', 'CO', 'PE'],
        event: {
          action: EventAction.CLICK,
          event: Event.F_ENVIOS99,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      {
        name: 'COMMON.MENU.SUBMENUS.PRODUCTS.TAILOR',
        href: PATH_PAGE99.product.tailor,
        countries: ['MX', 'CL', 'CO', 'PE'],
        event: {
          action: EventAction.CLICK,
          event: Event.F_TLM,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      {
        name: 'COMMON.MENU.SUBMENUS.PRODUCTS.FULFILL99',
        href: PATH_PAGE99.product.fulfill,
        countries: ['MX', 'CL'],
        event: {
          action: EventAction.CLICK,
          event: Event.F_FULFILL99,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      // {
      //   name: 'COMMON.MENU.SUBMENUS.PRODUCTS.CASH',
      //   href: PATH_PAGE99.product.cash,
      //   countries: ['MX', 'CO'],
      //   event: {
      //     action: EventAction.CLICK,
      //     event: Event.F_CASH99,
      //     category: EventCategory.HOME,
      //     value: 'Ordenes SS',
      //   },
      // },
      {
        name: 'COMMON.MENU.SUBMENUS.PRODUCTS.PUNTO99',
        href: PATH_PAGE99.product.punto,
        countries: ['MX'],
        event: {
          action: EventAction.CLICK,
          event: Event.F_PUNTO99,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      /*
      {
        name: 'COMMON.MENU.SUBMENUS.PRODUCTS.RUTA99',
        href: PATH_PAGE99.product.ruta,
        countries: ['MX', 'CL', 'CO', 'PE'],
        event: {
          action: EventAction.CLICK,
          event: Event.F_RUTA99,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      */
    ],
  },
  {
    headline: 'COMMON.MENU.INTEGRATIONS',
    countries: ['MX', 'CL', 'CO', 'PE'],
    children: [
      {
        name: 'LAYOUT.FOOTER.INTEGRATIONS.SHOP',
        hrefOriginal: PATH_PAGE99.integrations.shop,
        href: 'https://developers.99minutos.com/page/shopify',
        countries: ['MX', 'CL', 'CO', 'PE'],
        external: true,
        event: {
          action: EventAction.CLICK,
          event: Event.F_SHOPIFY,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      {
        name: 'LAYOUT.FOOTER.INTEGRATIONS.WC',
        hrefOriginal: PATH_PAGE99.integrations.wc,
        href: 'https://developers.99minutos.com/page/plugin-installation-woocommerce',
        countries: ['MX', 'CL', 'CO', 'PE'],
        external: true,
        event: {
          action: EventAction.CLICK,
          event: Event.F_WOOCOMMERCE,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      {
        name: 'LAYOUT.FOOTER.INTEGRATIONS.MAG',
        hrefOriginal: PATH_PAGE99.integrations.mag,
        href: 'https://example-99mxn.readme.io/page/plugin-installation-magento',
        countries: ['MX', 'CL', 'CO', 'PE'],
        external: true,
        event: {
          action: EventAction.CLICK,
          event: Event.F_MAGENTO,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      {
        name: 'LAYOUT.FOOTER.INTEGRATIONS.TIENDA',
        hrefOriginal: PATH_PAGE99.integrations.tienda,
        href: 'https://example-99mxn.readme.io/page/plugin-installation-tienda-nube',
        countries: ['MX', 'CL', 'CO', 'PE'],
        external: true,
        event: {
          action: EventAction.CLICK,
          event: Event.F_TIENDANUBE,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      {
        name: 'LAYOUT.FOOTER.INTEGRATIONS.JS',
        hrefOriginal: PATH_PAGE99.integrations.js,
        href: 'https://example-99mxn.readme.io/page/plugin-installation-jumpseller',
        countries: ['MX', 'CL', 'CO', 'PE'],
        external: true,
        event: {
          action: EventAction.CLICK,
          event: Event.F_JUMPSELLER,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      {
        name: 'LAYOUT.FOOTER.INTEGRATIONS.PS',
        hrefOriginal: PATH_PAGE99.integrations.ps,
        href: 'https://example-99mxn.readme.io/page/plugin-installation-prestashop',
        countries: ['MX', 'CL', 'CO', 'PE'],
        external: true,
        event: {
          action: EventAction.CLICK,
          event: Event.F_PRESTASHOP,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      {
        name: 'LAYOUT.FOOTER.INTEGRATIONS.BC',
        hrefOriginal: PATH_PAGE99.integrations.bc,
        href: 'https://example-99mxn.readme.io/page/api-installation-bigcommerce',
        countries: ['MX', 'CL', 'CO', 'PE'],
        external: true,
        event: {
          action: EventAction.CLICK,
          event: Event.F_BIGCOMMERCE,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      {
        name: 'LAYOUT.FOOTER.INTEGRATIONS.MELI',
        hrefOriginal: PATH_PAGE99.integrations.meli,
        href: 'https://developers.99minutos.com/page/meli-flex',
        countries: ['MX', 'CL', 'CO', 'PE'],
        external: true,
        event: {
          action: EventAction.CLICK,
          event: Event.F_MELIFLEX,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
      {
        name: 'LAYOUT.FOOTER.INTEGRATIONS.API',
        hrefOriginal: PATH_PAGE99.integrations.api,
        href: 'https://developers.99minutos.com/',
        countries: ['MX', 'CL', 'CO', 'PE'],
        external: true,
        event: {
          action: EventAction.CLICK,
          event: Event.F_API,
          category: EventCategory.HOME,
          value: 'Ordenes SS',
        },
      },
    ],
  },
  {
    headline: 'COMMON.MENU.WORK_WITH_US',
    countries: ['MX'],
    children: [
      {
        name: 'LAYOUT.FOOTER.WORK_WITH_US.FREELANCE',
        href: '/freelance',
        countries: ['MX'],
        event: {
          action: EventAction.CLICK,
          event: Event.F_FREELANCE,
          category: EventCategory.HOME,
          value: 'Repartidores Freelance',
        },
      },
      {
        name: 'LAYOUT.FOOTER.WORK_WITH_US.PUNTO99',
        href: '/punto99-delivery-center',
        countries: ['MX'],
        event: {
          action: EventAction.CLICK,
          event: Event.F_PUNTO99WORK,
          category: EventCategory.HOME,
          value: 'Punto99yCentroDeReparto',
        },
      },
      {
        name: 'LAYOUT.FOOTER.WORK_WITH_US.BASE_DISTRIBUTORS',
        href: '/base-distributors',
        countries: ['MX'],
        event: {
          action: EventAction.CLICK,
          event: Event.F_BASE_DISTRIBUTORS,
          category: EventCategory.HOME,
          value: 'RepartidoresBase',
        },
      },
      {
        name: 'LAYOUT.FOOTER.WORK_WITH_US.STRATEGIC_ALLIES',
        href: '/strategic-allies',
        countries: ['MX'],
        event: {
          action: EventAction.CLICK,
          event: Event.F_STRATEGIC_ALLIES,
          category: EventCategory.HOME,
          value: 'AliadosEstrategicos',
        },
      },
      {
        name: 'LAYOUT.FOOTER.WORK_WITH_US.SERVICE_PROVIDERS',
        href: '/service-partner',
        countries: ['MX'],
        event: {
          action: EventAction.CLICK,
          event: Event.F_SERVICE_PARTNER,
          category: EventCategory.HOME,
          value: 'ProveedoresDeServicios',
        },
      },
    ],
  },
];

export const LINKS_OTHERS: ILinksOthers = {
  MX: [
    {
      headline: 'COMMON.MENU.PARTNERSHIP',
      action: Action.Link,
      href: '/partnership',
      target: '_blank',
      event: {
        action: EventAction.CLICK,
        event: Event.F_PATNERSHIP,
        category: EventCategory.HOME,
        value: 'Partnership',
      },
    },
    {
      headline: 'COMMON.MENU.SUPPORT',
      action: Action.Link,
      href: PATH_ZENDESK,
      target: '_blank',
      event: {
        action: EventAction.CLICK,
        event: Event.F_SOPORTE,
        category: EventCategory.HOME,
        value: 'Soporte',
      },
    },
    {
      headline: 'COMMON.MENU.BLOG',
      action: Action.Link,
      href: '/blog',
      event: {
        action: EventAction.CLICK,
        event: Event.F_BLOG,
        category: EventCategory.HOME,
        value: 'Blog',
      },
    },
    {
      headline: 'COMMON.MENU.INVOICE',
      action: Action.Modal,
      modal: 'invoice',
      event: {
        action: EventAction.CLICK,
        event: Event.F_FACTURACION,
        category: EventCategory.HOME,
        value: 'Facturacion',
      },
    },
    /* {
      headline: 'COMMON.MENU.SERVICE_STATUS',
      action: Action.Link,
      href: PATH_SERVICE_STATUS,
      target: '_blank',
      event: {
        action: EventAction.CLICK,
        event: Event.F_SERVICESTATUS,
        category: EventCategory.HOME,
        value: 'Service Status',
      },
    }, */
  ],
  CL: [
    {
      headline: 'COMMON.MENU.RATES',
      action: Action.Link,
      href: PATH_PAGE99.rates,
      event: {
        action: EventAction.CLICK,
        event: Event.F_TARIFAS,
        category: EventCategory.HOME,
        value: 'Tarifas',
      },
    },
    {
      headline: 'COMMON.MENU.SUPPLIER',
      action: Action.Link,
      href: PATH_SUPPLIER,
      target: '_blank',
      event: {
        action: EventAction.CLICK,
        event: Event.F_PROVEEDORES,
        category: EventCategory.HOME,
        value: 'Proveedores',
      },
    },
    {
      headline: 'COMMON.MENU.SUPPORT',
      action: Action.Link,
      href: PATH_ZENDESK,
      target: '_blank',
      event: {
        action: EventAction.CLICK,
        event: Event.F_SOPORTE,
        category: EventCategory.HOME,
        value: 'Soporte',
      },
    },
    {
      headline: 'COMMON.MENU.BLOG',
      action: Action.Link,
      href: '/blog',
      event: {
        action: EventAction.CLICK,
        event: Event.F_BLOG,
        category: EventCategory.HOME,
        value: 'Blog',
      },
    },
    {
      headline: 'COMMON.MENU.INVOICE',
      action: Action.Modal,
      modal: 'invoice',
      event: {
        action: EventAction.CLICK,
        event: Event.F_FACTURACION,
        category: EventCategory.HOME,
        value: 'Facturacion',
      },
    },
    /* {
      headline: 'COMMON.MENU.SERVICE_STATUS',
      action: Action.Link,
      href: PATH_SERVICE_STATUS,
      target: '_blank',
      event: {
        action: EventAction.CLICK,
        event: Event.F_SERVICESTATUS,
        category: EventCategory.HOME,
        value: 'Service Status',
      },
    }, */
  ],
  PE: [
    {
      headline: 'COMMON.MENU.RATES',
      action: Action.Link,
      href: PATH_PAGE99.rates,
      event: {
        action: EventAction.CLICK,
        event: Event.F_TARIFAS,
        category: EventCategory.HOME,
        value: 'Tarifas',
      },
    },
    {
      headline: 'COMMON.MENU.SUPPORT',
      action: Action.Link,
      href: PATH_ZENDESK,
      target: '_blank',
      event: {
        action: EventAction.CLICK,
        event: Event.F_SOPORTE,
        category: EventCategory.HOME,
        value: 'Soporte',
      },
    },
    {
      headline: 'COMMON.MENU.BLOG',
      action: Action.Link,
      href: '/blog',
      event: {
        action: EventAction.CLICK,
        event: Event.F_BLOG,
        category: EventCategory.HOME,
        value: 'Blog',
      },
    },
    {
      headline: 'COMMON.MENU.INVOICE',
      action: Action.Modal,
      modal: 'invoice',
      event: {
        action: EventAction.CLICK,
        event: Event.F_FACTURACION,
        category: EventCategory.HOME,
        value: 'Facturacion',
      },
    },
    {
      headline: 'COMMON.MENU.CLAIMS_PER',
      action: Action.Link,
      href: PATH_CLAIMS_PER,
      target: '_blank',
      event: {
        action: EventAction.CLICK,
        event: Event.F_POLITICAS,
        category: EventCategory.HOME,
        value: 'Politicas',
      },
    },
    /* {
      headline: 'COMMON.MENU.SERVICE_STATUS',
      action: Action.Link,
      href: PATH_SERVICE_STATUS,
      target: '_blank',
      event: {
        action: EventAction.CLICK,
        event: Event.F_SERVICESTATUS,
        category: EventCategory.HOME,
        value: 'Service Status',
      },
    }, */
  ],
  CO: [
    {
      headline: 'COMMON.MENU.RATES',
      action: Action.Link,
      href: PATH_PAGE99.rates,
      event: {
        action: EventAction.CLICK,
        event: Event.F_TARIFAS,
        category: EventCategory.HOME,
        value: 'Tarifas',
      },
    },
    {
      headline: 'COMMON.MENU.SUPPORT',
      action: Action.Link,
      href: PATH_ZENDESK_COL,
      target: '_blank',
      event: {
        action: EventAction.CLICK,
        event: Event.F_SOPORTE,
        category: EventCategory.HOME,
        value: 'Soporte',
      },
    },
    {
      headline: 'COMMON.MENU.BLOG',
      action: Action.Link,
      href: '/blog',
      event: {
        action: EventAction.CLICK,
        event: Event.F_BLOG,
        category: EventCategory.HOME,
        value: 'Blog',
      },
    },
    {
      headline: 'COMMON.MENU.INVOICE',
      action: Action.Modal,
      modal: 'invoice',
      event: {
        action: EventAction.CLICK,
        event: Event.F_FACTURACION,
        category: EventCategory.HOME,
        value: 'Facturacion',
      },
    },
    {
      headline: 'COMMON.MENU.CLAIMS_COL',
      action: Action.Link,
      href: PATH_CLAIMS_COL,
      target: '_blank',
      event: {
        action: EventAction.CLICK,
        event: Event.F_POLITICAS,
        category: EventCategory.HOME,
        value: 'Politicas',
      },
    },
    /* {
      headline: 'COMMON.MENU.SERVICE_STATUS',
      action: Action.Link,
      href: PATH_SERVICE_STATUS,
      target: '_blank',
      event: {
        action: EventAction.CLICK,
        event: Event.F_SERVICESTATUS,
        category: EventCategory.HOME,
        value: 'Service Status',
      },
    }, */
  ],
};

export const media: IMedia = {
  MX: [
    {
      name: 'Linkedin',
      path: 'icon_linkedin.svg',
      url: PATH_LINKEDIN,
      event: {
        action: EventAction.CLICK,
        event: Event.B_LINKEDIN,
        category: EventCategory.HOME,
        value: 'Linkendin',
      },
    },
    {
      name: 'Instagram',
      path: 'icon_instagram.svg',
      url: PATH_INSTAGRAM_LATAM,
      event: {
        action: EventAction.CLICK,
        event: Event.B_INSTAGRAM,
        category: EventCategory.HOME,
        value: 'Instagram',
      },
    },
    {
      name: 'Facebook',
      path: 'icon_facebook.svg',
      url: PATH_FACEBOOK,
      event: {
        action: EventAction.CLICK,
        event: Event.B_FACEBOOK,
        category: EventCategory.HOME,
        value: 'Facebook',
      },
    },
    {
      name: 'Youtube',
      path: 'icon_youtube.svg',
      url: PATH_YOUTUBE,
      event: {
        action: EventAction.CLICK,
        event: Event.B_YOUTUBE,
        category: EventCategory.HOME,
        value: 'Youtube',
      },
    },
    {
      name: 'TikTok',
      path: 'icon_tiktok.svg',
      url: PATH_TIKTOK,
      event: {
        action: EventAction.CLICK,
        event: Event.B_TIKTOK,
        category: EventCategory.HOME,
        value: 'TikTok',
      },
    },
    // {
    //   name: 'WhatsApp',
    //   path: 'icon_whatsapp.svg',
    //   url: PATH_WHATSAPP_CALL,
    //   event: {
    //     action: EventAction.CLICK,
    //     event: Event.B_WHATSAPP,
    //     category: EventCategory.HOME,
    //     value: 'WhatsApp',
    //   },
    // },
  ],
  CO: [
    {
      name: 'Linkedin',
      path: 'icon_linkedin.svg',
      url: PATH_LINKEDIN,
      event: {
        action: EventAction.CLICK,
        event: Event.B_LINKEDIN,
        category: EventCategory.HOME,
        value: 'Linkendin',
      },
    },
    {
      name: 'Instagram',
      path: 'icon_instagram.svg',
      url: PATH_INSTAGRAM_LATAM,
      event: {
        action: EventAction.CLICK,
        event: Event.B_INSTAGRAM,
        category: EventCategory.HOME,
        value: 'Instagram',
      },
    },
    {
      name: 'Facebook',
      path: 'icon_facebook.svg',
      url: PATH_FACEBOOK,
      event: {
        action: EventAction.CLICK,
        event: Event.B_FACEBOOK,
        category: EventCategory.HOME,
        value: 'Facebook',
      },
    },
    {
      name: 'Youtube',
      path: 'icon_youtube.svg',
      url: PATH_YOUTUBE,
      event: {
        action: EventAction.CLICK,
        event: Event.B_YOUTUBE,
        category: EventCategory.HOME,
        value: 'Youtube',
      },
    },
    {
      name: 'TikTok',
      path: 'icon_tiktok.svg',
      url: PATH_TIKTOK,
      event: {
        action: EventAction.CLICK,
        event: Event.B_TIKTOK,
        category: EventCategory.HOME,
        value: 'TikTok',
      },
    },
    // {
    //   name: 'WhatsApp',
    //   path: 'icon_whatsapp.svg',
    //   url: PATH_WHATSAPP_CALL,
    //   event: {
    //     action: EventAction.CLICK,
    //     event: Event.B_WHATSAPP,
    //     category: EventCategory.HOME,
    //     value: 'WhatsApp',
    //   },
    // },
  ],
  PE: [
    {
      name: 'Linkedin',
      path: 'icon_linkedin.svg',
      url: PATH_LINKEDIN,
      event: {
        action: EventAction.CLICK,
        event: Event.B_LINKEDIN,
        category: EventCategory.HOME,
        value: 'Linkendin',
      },
    },
    {
      name: 'Instagram',
      path: 'icon_instagram.svg',
      url: PATH_INSTAGRAM_LATAM,
      event: {
        action: EventAction.CLICK,
        event: Event.B_INSTAGRAM,
        category: EventCategory.HOME,
        value: 'Instagram',
      },
    },
    {
      name: 'Facebook',
      path: 'icon_facebook.svg',
      url: PATH_FACEBOOK,
      event: {
        action: EventAction.CLICK,
        event: Event.B_FACEBOOK,
        category: EventCategory.HOME,
        value: 'Facebook',
      },
    },
    {
      name: 'Youtube',
      path: 'icon_youtube.svg',
      url: PATH_YOUTUBE,
      event: {
        action: EventAction.CLICK,
        event: Event.B_YOUTUBE,
        category: EventCategory.HOME,
        value: 'Youtube',
      },
    },
    {
      name: 'TikTok',
      path: 'icon_tiktok.svg',
      url: PATH_TIKTOK,
      event: {
        action: EventAction.CLICK,
        event: Event.B_TIKTOK,
        category: EventCategory.HOME,
        value: 'TikTok',
      },
    },
    // {
    //   name: 'WhatsApp',
    //   path: 'icon_whatsapp.svg',
    //   url: PATH_WHATSAPP_CALL,
    //   event: {
    //     action: EventAction.CLICK,
    //     event: Event.B_WHATSAPP,
    //     category: EventCategory.HOME,
    //     value: 'WhatsApp',
    //   },
    // },
  ],
  CL: [
    {
      name: 'Linkedin',
      path: 'icon_linkedin.svg',
      url: PATH_LINKEDIN,
      event: {
        action: EventAction.CLICK,
        event: Event.B_LINKEDIN,
        category: EventCategory.HOME,
        value: 'Linkendin',
      },
    },
    {
      name: 'Instagram',
      path: 'icon_instagram.svg',
      url: PATH_INSTAGRAM_CHL,
      event: {
        action: EventAction.CLICK,
        event: Event.B_INSTAGRAM,
        category: EventCategory.HOME,
        value: 'Instagram',
      },
    },
    {
      name: 'Facebook',
      path: 'icon_facebook.svg',
      url: PATH_FACEBOOK,
      event: {
        action: EventAction.CLICK,
        event: Event.B_FACEBOOK,
        category: EventCategory.HOME,
        value: 'Facebook',
      },
    },
    {
      name: 'Youtube',
      path: 'icon_youtube.svg',
      url: PATH_YOUTUBE,
      event: {
        action: EventAction.CLICK,
        event: Event.B_YOUTUBE,
        category: EventCategory.HOME,
        value: 'Youtube',
      },
    },
    {
      name: 'TikTok',
      path: 'icon_tiktok.svg',
      url: PATH_TIKTOK,
      event: {
        action: EventAction.CLICK,
        event: Event.B_TIKTOK,
        category: EventCategory.HOME,
        value: 'TikTok',
      },
    },
    // {
    //   name: 'WhatsApp',
    //   path: 'icon_whatsapp.svg',
    //   url: PATH_WHATSAPP_CALL,
    //   event: {
    //     action: EventAction.CLICK,
    //     event: Event.B_WHATSAPP,
    //     category: EventCategory.HOME,
    //     value: 'WhatsApp',
    //   },
    // },
  ],
};

export const rights: IRightsValues[] = [
  {
    name: 'LAYOUT.FOOTER.LEGAL.TERMS',
    path: '/terms',
    event: {
      action: EventAction.CLICK,
      event: Event.F_TYC,
      category: EventCategory.HOME,
      value: 'Terminos y Condiciones',
    },
    countries: ['MX', 'CL', 'CO', 'PE'],
  },
  {
    name: 'LAYOUT.FOOTER.LEGAL.PRIVACY',
    path: '/privacy',
    event: {
      action: EventAction.CLICK,
      event: Event.F_TYC,
      category: EventCategory.HOME,
      value: 'Politicas de Privacidad',
    },
    countries: ['MX', 'CL', 'CO', 'PE'],
  },
  {
    name: 'LAYOUT.FOOTER.LEGAL.TERMSVENDORS',
    path: '/terms-vendors',
    event: {
      action: EventAction.CLICK,
      event: Event.F_TYCPROVEEDORES,
      category: EventCategory.HOME,
      value: 'Terminos y Condiciones Proveedores',
    },
    countries: ['MX'],
  },
  {
    name: 'LAYOUT.FOOTER.LEGAL.PRIVACYVENDORS',
    path: '/privacy-vendors',
    event: {
      action: EventAction.CLICK,
      event: Event.F_POLITICASPROVEEDORES,
      category: EventCategory.HOME,
      value: 'Politicas de Privacidad Proveedores',
    },
    countries: ['MX'],
  },
];

export const getInvoices: GetInvoices = {
  MX: {
    items: [
      'GET_INVOICES.MX.STEP_1',
      'GET_INVOICES.MX.STEP_2',
      'GET_INVOICES.MX.STEP_3',
      'GET_INVOICES.MX.STEP_4',
      'GET_INVOICES.MX.STEP_5',
    ],
  },
  CO: {
    subtitle: 'GET_INVOICES.CO.SUBTITLE',
    mailto: 'GET_INVOICES.CO.MAILTO',
    items: [
      {
        title: 'GET_INVOICES.CO.TITLE_1',
        children: [
          'GET_INVOICES.CO.FIRST_SECTION.STEP_1',
          'GET_INVOICES.CO.FIRST_SECTION.STEP_2',
          'GET_INVOICES.CO.FIRST_SECTION.STEP_3',
          'GET_INVOICES.CO.FIRST_SECTION.STEP_4',
          'GET_INVOICES.CO.FIRST_SECTION.STEP_5',
          'GET_INVOICES.CO.FIRST_SECTION.STEP_6',
          'GET_INVOICES.CO.FIRST_SECTION.STEP_7',
          'GET_INVOICES.CO.FIRST_SECTION.STEP_8',
          'GET_INVOICES.CO.FIRST_SECTION.STEP_9',
        ],
      },
      {
        title: 'GET_INVOICES.CO.TITLE_2',
        children: [
          'GET_INVOICES.CO.SECOND_SECTION.STEP_1',
          'GET_INVOICES.CO.SECOND_SECTION.STEP_2',
          'GET_INVOICES.CO.SECOND_SECTION.STEP_3',
          'GET_INVOICES.CO.SECOND_SECTION.STEP_4',
          'GET_INVOICES.CO.SECOND_SECTION.STEP_5',
          'GET_INVOICES.CO.SECOND_SECTION.STEP_6',
          'GET_INVOICES.CO.SECOND_SECTION.STEP_7',
        ],
      },
    ],
  },
  CL: {
    items: ['GET_INVOICES.CL.STEP_1', 'GET_INVOICES.CL.STEP_2'],
  },
  PE: {
    subtitle: 'GET_INVOICES.PE.SUBTITLE',
    mailto: 'GET_INVOICES.PE.MAILTO',
    mailtoCC: 'GET_INVOICES.PE.MAILTO_COPY',
    items: ['GET_INVOICES.PE.STEP_1', 'GET_INVOICES.PE.STEP_2'],
  },
};
